/**
 * Static-translations for da. Generated from:
 *  - `online/lang/static-translations.ts` (legacy, via KEY_MAP)
 *  - `tools/sdk-translations.mjs` (SDK-specific strings)
 *
 * Do not edit by hand — changes are lost on the next `node tools/gen-locales.mjs`.
 * To fix a translation, edit legacy/sdk-translations.mjs and regenerate.
 */
const da = {
  'anon.heading_default': 'Fortsæt som gæst',
  'anon.try_again': 'Prøv igen',
  'auth.back_to_login': 'Tilbage til login',
  'auth.check_email_message': 'Tjek din e-mail — vi har sendt en bekræftelseskode.',
  'auth.check_email_title': 'Tjek din e-mail',
  'auth.confirm_email_title': 'Bekræft din e-mail',
  'auth.confirmation_code': 'Bekræftelseskode',
  'auth.continue_with_apple': 'Fortsæt med Apple',
  'auth.continue_with_facebook': 'Fortsæt med Facebook',
  'auth.continue_with_github': 'Fortsæt med GitHub',
  'auth.continue_with_google': 'Fortsæt med Google',
  'auth.create_account': 'Opret konto',
  'auth.default_subtitle': 'Log ind for at få adgang til alle funktioner og synkronisere dine data.',
  'auth.email': 'E-mailadresse',
  'auth.email_already_registered': 'Denne e-mail er allerede registreret. Log ind nedenfor med din adgangskode eller den konto, du oprettede dig med.',
  'auth.email_exists': 'En konto med denne e-mail findes allerede.',
  'auth.email_not_confirmed': 'Bekræft venligst din e-mail først.',
  'auth.forgot_password': 'Glemt adgangskode?',
  'auth.forgot_password_title': 'Glemt adgangskode?',
  'auth.forgot_subtitle': 'Indtast din e-mail, så sender vi dig et link til nulstilling af adgangskode.',
  'auth.generic_error': 'Noget gik galt',
  'auth.have_account': 'Har du allerede en konto?',
  'auth.hide_password': 'Skjul adgangskode',
  'auth.identity_already_linked': 'Denne konto er allerede registreret. Log ind med den nedenfor.',
  'auth.invalid_credentials': 'Forkert e-mail eller adgangskode',
  'auth.invalid_otp': 'Koden er ugyldig eller udløbet.',
  'auth.last_used': 'Sidst brugt · {email}',
  'auth.last_used_no_email': 'Sidst brugt',
  'auth.link_purchase_subheading': 'Vi knytter købet til din konto, så adgangen bevares.',
  'auth.log_in': 'Log Ind',
  'auth.log_in_link': 'Log Ind',
  'auth.login_continue_purchase': 'Log ind for at fortsætte dit køb',
  'auth.network_error': 'Netværksfejl. Tjek forbindelsen, og prøv igen.',
  'auth.no_account': 'Har du ingen konto?',
  'auth.or': 'eller',
  'auth.password': 'Adgangskode',
  'auth.passwords_mismatch': 'Adgangskoder matcher ikke',
  'auth.rate_limited': 'For mange anmodninger. Prøv igen senere.',
  'auth.repeat_password': 'Gentag adgangskode',
  'auth.reset_link_valid': 'Linket er gyldigt i 1 time.',
  'auth.reset_password_title': 'Nulstil adgangskode',
  'auth.reset_sent_message': 'Hvis den e-mail findes, er der sendt en nulstillingskode.',
  'auth.reset_sent_subtitle': 'Vi har sendt et link til at nulstille adgangskoden. Følg instruktionerne i e-mailen.',
  'auth.restore_purchases_heading': 'Gendan Køb',
  'auth.restore_purchases_subheading': 'Log ind for at gendanne dine køb.',
  'auth.send_reset': 'Send Nulstillingsmail',
  'auth.service_unavailable': 'Tjenesten er midlertidigt utilgængelig. Prøv igen senere.',
  'auth.show_password': 'Vis adgangskode',
  'auth.sign_out': 'Log ud',
  'auth.sign_up': 'Tilmeld',
  'auth.sign_up_link': 'Tilmeld',
  'auth.signed_in': 'Logget ind',
  'auth.signin_failed': 'Login mislykkedes',
  'auth.signup_failed': 'Registrering mislykkedes',
  'auth.verify': 'Bekræft',
  'auth.weak_password': 'Adgangskoden er for svag.',
  'auth.welcome': 'Velkommen!',
  'auth.welcome_signup': 'Velkommen!',
  'cta.close': 'Luk',
  'cta.continue': 'Fortsæt',
  'cta.get_lifetime_access': 'Få livstidsadgang',
  'cta.get_plan_daily': 'Få daglig plan',
  'cta.get_plan_monthly': 'Få månedlig plan',
  'cta.get_plan_weekly': 'Få ugentlig plan',
  'cta.get_plan_yearly': 'Få årlig plan',
  'cta.start_trial': 'Start {days} Dages Gratis Prøveperiode',
  'modal.close_aria': 'Luk',
  'modal.continue': 'Fortsæt',
  'modal.error_generic': 'Noget gik galt',
  'modal.loading': 'Indlæser…',
  'modal.purchase_restored_subtitle': 'Alt er klar — god fornøjelse!',
  'modal.purchase_restored_title': 'Velkommen tilbage',
  'modal.purchase_success_subtitle': 'Alt er klar — god fornøjelse!',
  'modal.purchase_success_title': 'Betaling modtaget',
  'modal.verifying_subscription': 'Kontrollerer abonnement…',
  'nav.back': '← Tilbage',
  'nav.back_aria': 'Tilbage',
  'offer.limited_time': 'Tidsbegrænset tilbud',
  'payment.awaiting_title': 'Afslut betalingen i den nye fane',
  'payment.checking': 'Kontrollerer…',
  'payment.ive_paid': 'Jeg har betalt',
  'payment.open_checkout_again': 'Åbn betaling igen',
  'payment.open_checkout_button': 'Åbn betaling',
  'pricing.free_trial_days': '{days}-dages gratis prøveperiode',
  'pricing.included_per': 'Inkluderet pr. {interval}:',
  'pricing.interval.day': 'dag',
  'pricing.interval.lifetime_short': 'livstid',
  'pricing.interval.month': 'måned',
  'pricing.interval.period': 'periode',
  'pricing.interval.week': 'uge',
  'pricing.interval.year': 'år',
  'pricing.money_back': '30 dages pengene-tilbage-garanti',
  'pricing.most_popular': 'Mest populær',
  'pricing.no_prices': 'Ingen priser tilgængelige.',
  'pricing.plan_label.daily': 'DAGLIG PLAN',
  'pricing.plan_label.lifetime': 'livstid',
  'pricing.plan_label.monthly': 'månedlig plan',
  'pricing.plan_label.weekly': 'ugentlig plan',
  'pricing.plan_label.yearly': 'årlig plan',
  'pricing.plans_aria': 'Planer',
  'session.contact_support': 'Kontakt support',
  'session.restore_purchases': 'Gendan køb',
  'session.sign_out': 'Log ud',
  'session.signed_in_as_prefix': 'Logget ind som',
  'session.signing_out': 'Logger ud…',
  'support.attachments_label': 'Vedhæftninger',
  'support.close_button': 'Luk',
  'support.done_button': 'Færdig',
  'support.email_placeholder': 'Indtast din e-mail',
  'support.heading': 'Support',
  'support.instruction': 'Udfyld venligst formularen nedenfor for at indsende din supportanmodning.',
  'support.invalid_email': 'Ugyldig e-mail',
  'support.message_length': '1–5000 tegn',
  'support.message_placeholder': 'Indtast din besked',
  'support.required': 'Påkrævet',
  'support.send_another': 'Send endnu en anmodning',
  'support.send_button': 'Send',
  'support.sending': 'Sender…',
  'support.subject_length': '3–200 tegn',
  'support.subject_placeholder': 'Indtast dit emne',
  'support.success_heading': 'Anmodning sendt',
  'support.success_message_prefix': 'Vi har modtaget din besked og vil svare på'
} as const;

export default da;
